import { useInfiniteQuery } from '@tanstack/react-query';
import { concat, isEmpty } from 'lodash';
import { type IProductCategoriesWithProducts } from 'src/interfaces';
import { generateQuery, queryKeys, requestCCApi } from 'src/utils';

export const useGetProductCategoriesWithProducts = (filters: string[] = []) =>
  useInfiniteQuery({
    queryKey: queryKeys.viewProductCategoriesWithProducts.pagination(filters),
    queryFn: ({ pageParam = 1 }) =>
      fetchPaginatedProductCategoriesWithProducts(pageParam, filters),
    staleTime: Infinity,
    getNextPageParam: (lastPage, allPages) => {
      const currentPage = lastPage ? allPages.length : 1;
      const totalPages = lastPage ? lastPage?.totalPages : 1;

      return currentPage < totalPages ? currentPage + 1 : undefined;
    },
    enabled: !isEmpty(filters),
  });

const fetchPaginatedProductCategoriesWithProducts = async (
  page: number,
  filters: string[],
) => {
  const response = await requestCCApi({
    url: `/viewProductCategoriesWithProducts${generateQuery(
      [],
      concat(filters, [`count=true`, `page=${page}`]),
    )}`,
  });

  return {
    data: (response?.data ?? []) as IProductCategoriesWithProducts[],
    totalPages: response?.totalPages ?? 0,
    totalCount: response?.totalCount ?? 0,
  };
};
